import { render, staticRenderFns } from "./SetupPackage.vue?vue&type=template&id=2acb6d5d&scoped=true&"
import script from "./SetupPackage.vue?vue&type=script&lang=js&"
export * from "./SetupPackage.vue?vue&type=script&lang=js&"
import style1 from "./SetupPackage.vue?vue&type=style&index=1&id=2acb6d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb6d5d",
  null
  
)

export default component.exports